var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.6913 18.2811L6.19958 21.5236C5.70934 21.7898 5.09782 21.6121 4.82362 21.1239C4.74354 20.9704 4.70119 20.7998 4.70013 20.6264V13.3683C4.70013 14.0879 5.10587 14.5321 6.17312 15.0296L12.6913 18.2811Z",
    fill: "#E8C364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7696 1.65955C18.4774 1.65955 20.6737 2.7256 20.7001 5.45291V20.6264C20.6991 20.7969 20.6567 20.9647 20.5767 21.115C20.4481 21.3602 20.2261 21.5422 19.9616 21.6193C19.6971 21.6964 19.4129 21.6618 19.1742 21.5236L12.6913 18.2811L6.17312 15.0296C5.10587 14.5321 4.70013 14.0879 4.70013 13.3683V5.45291C4.70013 2.7256 6.89639 1.65955 9.59539 1.65955H15.7696ZM16.4488 7.70051H8.92505C8.49151 7.70051 8.14005 8.0545 8.14005 8.49116C8.14005 8.92783 8.49151 9.28182 8.92505 9.28182H16.4488C16.8823 9.28182 17.2338 8.92783 17.2338 8.49116C17.2338 8.0545 16.8823 7.70051 16.4488 7.70051Z",
    fill: "#E8C364"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.777466 0.0546875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.92fe5f662d2629f37849a8bf6eb35897.svg";
export { ForwardRef as ReactComponent };